/* SoCal Va'a — Salt & Ink motion (port of mockup v4, production-adapted) */
(function(){
  var sysRm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dm = !!(window.Shopify && Shopify.designMode);
  var rm = sysRm || dm; /* theme editor renders everything static — WYSIWYG */
  if(rm) document.documentElement.classList.add('sv-rm');

  /* intro screen-print pull — once per session */
  var intro = document.querySelector('.sv-intro');
  function heroGo(){ document.body.classList.add('sv-hero-in'); }
  if(intro){
    var seen = false;
    try{ seen = sessionStorage.getItem('svIntroSeen') === '1'; }catch(e){}
    if(rm || seen){ intro.classList.add('skip'); heroGo(); }
    else{
      var fired = false;
      var pull = function(){
        if(fired) return; fired = true;
        try{ sessionStorage.setItem('svIntroSeen','1'); }catch(e){}
        intro.classList.add('go');
        setTimeout(heroGo, 320);
        setTimeout(function(){ intro.remove(); }, 1100);
      };
      if(document.readyState === 'complete') setTimeout(pull, 450);
      else{ window.addEventListener('load', function(){ setTimeout(pull, 250); }); setTimeout(pull, 900); }
    }
  } else { heroGo(); }

  /* reveals — IO + synchronous sweep fallback */
  var pending = Array.prototype.slice.call(document.querySelectorAll('.sv-reveal,.sv-mline,.sv-maskimg,.sv-slam'));
  function markIn(el){ el.classList.add('in'); }
  if(rm){ pending.forEach(markIn); pending = []; }
  else if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ markIn(e.target); io.unobserve(e.target); } }); }, {threshold:.16, rootMargin:'0px 0px -8% 0px'});
    pending.forEach(function(el){ io.observe(el); });
  } else { pending.forEach(markIn); pending = []; }
  function sweep(){
    if(!pending.length) return;
    var limit = window.innerHeight * .92, keep = [];
    for(var i=0;i<pending.length;i++){ var el = pending[i]; if(el.classList.contains('in')) continue; if(el.getBoundingClientRect().top < limit) markIn(el); else keep.push(el); }
    pending = keep;
  }

  /* counters */
  var nums = Array.prototype.slice.call(document.querySelectorAll('.sv-proof .num[data-count]'));
  function runCounter(el){
    var t = parseInt(el.getAttribute('data-count'),10), pre = el.getAttribute('data-prefix')||'', suf = el.getAttribute('data-suffix')||'';
    if(isNaN(t)){ el.textContent = pre + el.getAttribute('data-count') + suf; return; }
    if(rm){ el.textContent = pre + t + suf; return; }
    var t0 = null, dur = 950;
    function tick(ts){ if(!t0) t0 = ts; var p = Math.min(1,(ts-t0)/dur); p = 1-Math.pow(1-p,3); el.textContent = pre + Math.round(t*p) + suf; if(p<1) requestAnimationFrame(tick); }
    requestAnimationFrame(tick);
    setTimeout(function(){ el.textContent = pre + t + suf; }, dur+250);
  }
  function fireCounter(el){ var i = nums.indexOf(el); if(i===-1) return; nums.splice(i,1); runCounter(el); }
  if('IntersectionObserver' in window && !rm){
    var cio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ fireCounter(e.target); cio.unobserve(e.target); } }); }, {threshold:.5});
    nums.slice().forEach(function(n){ cio.observe(n); });
  } else { nums.slice().forEach(fireCounter); }
  function sweepNums(){ if(!nums.length) return; var limit = window.innerHeight*.85; nums.slice().forEach(function(el){ if(el.getBoundingClientRect().top < limit) fireCounter(el); }); }

  /* marquee velocity skew */
  var marquees = document.querySelectorAll('.sv-marquee');
  var lastY = window.pageYOffset, skew = 0, lastRun = 0;
  function onScroll(){
    var now = performance.now();
    if(now - lastRun < 14) return; lastRun = now;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if(!rm){
      var v = y - lastY; lastY = y;
      skew += (Math.max(-9, Math.min(9, v*.35)) - skew) * .12;
      var s = 'skewX(' + skew.toFixed(2) + 'deg)';
      marquees.forEach(function(m){ m.style.transform = s; });
    }
    sweep(); sweepNums();
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  /* theme editor: re-rendered sections arrive as fresh DOM — show them
     statically and finish their counters instantly */
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target;
    root.querySelectorAll('.sv-reveal,.sv-mline,.sv-maskimg,.sv-slam').forEach(function(el){ el.classList.add('in'); });
    root.querySelectorAll('.sv-proof .num[data-count]').forEach(function(el){
      el.textContent = (el.getAttribute('data-prefix')||'') + el.getAttribute('data-count') + (el.getAttribute('data-suffix')||'');
    });
    document.body.classList.add('sv-hero-in');
  });
})();
